import React, { useEffect, useState } from 'react';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { FiSearch } from 'react-icons/fi';
import { DashboardContent } from '@/layouts/dashboard';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { TiaBanner } from '@/components/custom/tia-banner';
import { ComplementaryActivityPlayfulCard } from './ComplementaryActivityPlayfulCard';
import tiaAtividades from '@/assets/images/tia/TIA-ATIVIDADES.png';

export default function ComplementaryActivityPlayful({ uri }) {
  const { t } = useTranslation();
  const client = useClient();
  const [loading, setLoading] = useState(true);
  const [activities, setActivities] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const getActivities = async () => {
      setLoading(true);
      const { data, error } = await client.fetch('activities');
      if (error) {
        toast.error(t('toast.errorFetchComplementActivity'));
      } else {
        setActivities(data || []);
      }
      setLoading(false);
    };

    getActivities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredActivities = activities.filter(activity => searchTerm === '' || (activity.title != null && activity.title.toLowerCase().includes(searchTerm.toLowerCase())));

  const breadcrumbs = {
    title: 'Atividades',
    nav: [
      {
        route: uri,
        name: 'Atividade Complementar',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <TiaBanner
        className="mb-6 sm:mt-20"
        image={tiaAtividades}
        imageOffset={210}
        text="Bora colocar a mão na massa? Aqui estão suas atividades complementares. Fique de olho nos prazos e mande tudo certinho para não perder nenhum ponto! 💪"
      />

      <div className="mb-6">
        <div className="relative max-w-sm">
          <FiSearch className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-neutral-400" />
          <input
            type="search"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            placeholder={t('filter.searchActivity')}
            className="focus:ring-primary/30 w-full rounded-full border border-neutral-lightest bg-white py-2.5 pl-10 pr-4 text-sm font-semibold text-neutral-dark shadow-card focus:outline-none focus:ring-2"
          />
        </div>
      </div>

      {loading && <Loader />}

      {!loading && filteredActivities.length === 0 && (
        <EmptyState
          type="data"
          variant="plain"
          className="pt-16 sm:pt-32"
        />
      )}

      {!loading && filteredActivities.length > 0 && (
        <div className="grid animate-fade-in grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {filteredActivities.map(activity => (
            <ComplementaryActivityPlayfulCard
              key={activity.id}
              activity={activity}
            />
          ))}
        </div>
      )}
    </DashboardContent>
  );
}
